module.exports = __webpack_public_path__ + "img/blog-bg.6daa9837.jpg";